/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import type { Location } from 'history'
import { BetaFeature, isBetaFeatureEnabled } from '../shared'

export const getBetaFlag = (location: Location) => {
  const isGalleryDirect = isBetaFeatureEnabled(location, BetaFeature.GALLERY_DIRECT)
    ? VARIATIONS.GALLERY_DIRECT
    : undefined
  const isGalleryIndirect = isBetaFeatureEnabled(location, BetaFeature.GALLERY_INDIRECT)
    ? VARIATIONS.GALLERY_INDIRECT
    : undefined
  return isGalleryDirect || isGalleryIndirect
}

export const VARIATIONS = {
  GALLERY_DIRECT: 'GALLERY_DIRECT',
  GALLERY_INDIRECT: 'GALLERY_INDIRECT',
} as const

// Hardcoding this to the winning variation (in case we want to change it we just need to change this variable)
export const DEFAULT_VARIATION = VARIATIONS.GALLERY_DIRECT

/**
 * Determines whether we need to send user directly to the gallery landing experience
 */
export const isGalleryDirect = ({ isBot, location }: { isBot: boolean; location: Location }) => {
  if (isBot) return false
  const beta = getBetaFlag(location)
  if (beta) {
    return beta === VARIATIONS.GALLERY_DIRECT
  }
  return DEFAULT_VARIATION === VARIATIONS.GALLERY_DIRECT
}
